import { useEffect, useState } from "react"
import {
  collection,
  updateDoc,
  Timestamp,
  doc,
  deleteDoc,
  query,
  where,
  getDocs,
  getDoc,
} from "firebase/firestore"
import { ref, update, remove } from "firebase/database"
import { db, rtdb } from "../../../Firebase/config"
import Notify from "../Usenotifications"
import { useNavigate } from "react-router-dom"

export const GetoneDeliveryorderHook = (recentOrders, setRecentOrders) => {
  const [disable, setDisable] = useState(false)
  const [paid, setPaid] = useState("Not Ready")
  const navigate = useNavigate()

  const user = JSON.parse(localStorage.getItem("user"))

  // ✅ Function to update both Firestore & Realtime Database
  const updateBothDBs = async (orderId, updates) => {
    try {
      // Update Firestore
      await updateDoc(doc(db, "DeliveryOrders", orderId), updates)

      // Update Realtime Database
      const orderRef = ref(rtdb, `DeliveryOrders/${orderId}`)
      await update(orderRef, updates)
    } catch (error) {
      Notify("Failed to update order. Try again.", "error")
    }
  }

  const handleDelivered = async (orderId, userId, orderTotal) => {
    if (!userId || !user.name || !user.id) {
      Notify("❌ Missing required parameters!", "error")
      navigate("/Login")
      return
    }

    try {
      const updates = {
        delivered: true,
        deliveredAt: Timestamp.now(),
        DeliveredBy: user?.name || "Unknown",
        DriverID: user?.id || "Unknown",
        reviewpass: true,
      }

      await updateBothDBs(orderId, updates)

      Notify(` Order Delivered!`, "success")
    } catch (error) {
      console.error("❌ Error updating coins:", error)
      Notify("Failed to update coins. Try again.", "error")
    }
  }

  // ✅ Order On the Way
  const handleOntheway = async (orderId) => {
    if (!user.name || !user.id) {
      Notify(" Missing required parameters!", "error")
      navigate("/Login")
      return
    }
    const updates = {
      ontheWay: true,
      pickedAt: Timestamp.now(),
      PickedBy: user?.name || "Unknown",
    }
    await updateBothDBs(orderId, updates)
    Notify("Order Picked Up", "success")
  }

  // ✅ Mark as Checked
  const handleCheckDelivery = async (orderId) => {
    if (!user.name || !user.id) {
      Notify(" Missing required parameters!", "error")
      navigate("/Login")
      return
    }
    const today = new Date()
    const updates = {
      Checked: true,
      preparing: true,
      SeenAtDate: today.toDateString(),
      SeenAtTime: today.toLocaleTimeString(),
    }
    await updateBothDBs(orderId, updates)
  }

  // ✅ Done Preparing
  const handleDonepreparing = async (orderId) => {
    if (!user.name || !user.id) {
      Notify(" Missing required parameters!", "error")
      navigate("/Login")
      return
    }
    const updates = {
      Donepreparing: true,
      FinishedPreparingAt: Timestamp.now(),
    }
    await updateBothDBs(orderId, updates)
  }

  // ✅ Delete Order (Admin Only)
  const handleDelete = async (e, orderId) => {
    e.preventDefault()

    setRecentOrders((prevOrders) =>
      prevOrders.filter((order) => order.id !== orderId)
    )

    try {
      // Delete from Firestore
      await deleteDoc(doc(db, "Orders", orderId))

      // Delete from Realtime Database
      const orderRef = ref(rtdb, `DeliveryOrders/${orderId}`)
      await remove(orderRef)

      Notify("Order deleted", "success")

      setTimeout(() => {
        navigate("/adminallorders")
      }, 1500)
    } catch (error) {
      Notify("Failed to delete order. Try again.", "error")
    }
  }

  return [
    handleDonepreparing,
    handleDelete,
    disable,
    paid,
    handleOntheway,
    handleCheckDelivery,
    handleDelivered,
  ]
}
